/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Resource_Is_ListedInputs */

const en_admin_resource_form_resource_is_listed = /** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource is public`)
};

const de_admin_resource_form_resource_is_listed = /** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Ressource ist öffentlich`)
};

const es_admin_resource_form_resource_is_listed = /** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este recurso es público`)
};

const fr_admin_resource_form_resource_is_listed = /** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette ressource est publique`)
};

/** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */
const it_admin_resource_form_resource_is_listed = en_admin_resource_form_resource_is_listed;

/** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */
const pt_br2_admin_resource_form_resource_is_listed = en_admin_resource_form_resource_is_listed;

/** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */
const pl_admin_resource_form_resource_is_listed = en_admin_resource_form_resource_is_listed;

/** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */
const hu_admin_resource_form_resource_is_listed = en_admin_resource_form_resource_is_listed;

/** @type {(inputs: Admin_Resource_Form_Resource_Is_ListedInputs) => LocalizedString} */
const ro_admin_resource_form_resource_is_listed = en_admin_resource_form_resource_is_listed;

/**
* | output |
* | --- |
* | "Resource is public" |
*
* @param {Admin_Resource_Form_Resource_Is_ListedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_resource_is_listed = /** @type {((inputs?: Admin_Resource_Form_Resource_Is_ListedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Resource_Is_ListedInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_resource_is_listed(inputs)
	if (locale === "de") return de_admin_resource_form_resource_is_listed(inputs)
	if (locale === "es") return es_admin_resource_form_resource_is_listed(inputs)
	if (locale === "fr") return fr_admin_resource_form_resource_is_listed(inputs)
	if (locale === "it") return it_admin_resource_form_resource_is_listed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_resource_is_listed(inputs)
	if (locale === "pl") return pl_admin_resource_form_resource_is_listed(inputs)
	if (locale === "hu") return hu_admin_resource_form_resource_is_listed(inputs)
	return ro_admin_resource_form_resource_is_listed(inputs)
});
export { admin_resource_form_resource_is_listed as "admin.resource_form.resource_is_listed" }